export default __webpack_public_path__ + "static/media/gatito_rg.c0648449.jpg";